import React from "react";
import { useSelector } from "react-redux";
import { CardPrices } from "../../reusableUI/v2UI/CardsPrices";

export const BoxTotals = () => {
  const {
    total_ppto,
    total_gasto_real,
    porcentaje_gasto_real,
    total_por_gastar,
    porcentaje_por_gastar,
    total_pagado,
    total_por_pagar,
    total_gasto_final,
    separacion_miles,
    separacion_decimales,
    simbolo,
  } = useSelector((state) => state.pptoGasto.detail);

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-5 mt-3">
      <CardPrices
        title="PRESUPUESTO TOTAL"
        total={total_ppto}
        percent={0}
        label="Monto aprobado"
        bgColor="bg-black-500"
        textColor="text-black-500"
        formatMoney={{
          thousandSeparator: separacion_miles,
          decimalSeparator: separacion_decimales,
          prefix: simbolo,
        }}
        hasProgress={false}
      />

      <CardPrices
        title="GASTADO"
        total={total_gasto_real}
        percent={porcentaje_gasto_real ? porcentaje_gasto_real : 0}
        label="del presupuesto"
        bgColor="bg-orange-600"
        textColor="text-orange-600"
        formatMoney={{
          thousandSeparator: separacion_miles,
          decimalSeparator: separacion_decimales,
          prefix: simbolo,
        }}
      />

      <CardPrices
        title="POR GASTAR"
        total={total_por_gastar}
        percent={porcentaje_por_gastar ? porcentaje_por_gastar : 0}
        label="disponible"
        bgColor="bg-blue-600"
        textColor="text-blue-600"
        formatMoney={{
          thousandSeparator: separacion_miles,
          decimalSeparator: separacion_decimales,
          prefix: simbolo,
        }}
      />

      <CardPrices
        title="PAGADO"
        total={total_pagado}
        percent={
          total_pagado
            ? (parseFloat(total_pagado) / parseFloat(total_gasto_final)) * 100
            : 0
        }
        label="de lo gastado"
        bgColor="bg-green-600"
        textColor="text-green-600"
        formatMoney={{
          thousandSeparator: separacion_miles,
          decimalSeparator: separacion_decimales,
          prefix: simbolo,
        }}
      />

      <CardPrices
        title="POR PAGAR"
        total={total_por_pagar}
        percent={
          total_por_pagar
            ? (parseFloat(total_por_pagar) / parseFloat(total_gasto_final)) *
              100
            : 0
        }
        label="pendiente"
        bgColor="bg-red-600"
        textColor="text-red-600"
        formatMoney={{
          thousandSeparator: separacion_miles,
          decimalSeparator: separacion_decimales,
          prefix: simbolo,
        }}
      />
    </div>
  );
};
